import React, { useState } from 'react';
import { useUrlSearchParams } from "use-url-search-params";
import { useTranslation } from "react-i18next";

import { useFunctionNames } from "modules/functionRegister/hooks";

import { Breadcrumb, Table } from 'antd';

import Pagination from "containers/Pagination";

import Title from "components/Title";
import Spacer from "components/Spacer";
import Container from "components/Container";

import FilterList from "./components/FilterList";

import { renderTextWithLink } from "lib/renderTextWithLink";

const FunctionNames = () => {
    const { t, i18n } = useTranslation();

    const [params, setParams] = useUrlSearchParams();
    const [search, setSearch] = useState(0);

    const defaultParams = {
        search,
        page: params.page,
        perPage: params.perPage,
        filter: [
            {
                key: `name`,
                operation: "%_%",
                value: params.name,
                type: "JSON",
            },
            {
                key: "organizations.id",
                operation: "=",
                value: params.organization_id,
                type: "STRING",
            }
        ],
    }

    const { items: functionNames, meta, isFetched: isFunctionNamesFetched } = useFunctionNames({
        params: defaultParams,
    });

    return (
        <Container>
            <Spacer size={35} />

            <Breadcrumb separator=">">
                <Breadcrumb.Item href='/'>{t('home')}</Breadcrumb.Item>
                <Breadcrumb.Item >{t('function_names')}</Breadcrumb.Item>
            </Breadcrumb>

            <Spacer size={32} />

            <Title align='left' text={t('function_names')} />

            <Spacer size={40} />

            <FilterList {...{ params, setParams, setSearch }} />
            <Spacer size={20} />

            <Table
                rowKey="id"
                defaultSort="-id"
                columns={[
                    {
                        title: "№",
                        render: (_, __, index) =>
                            (meta.current - 1) * meta.perPage + index + 1,
                    },
                    {
                        key: "name",
                        title: t("column_function_name"),
                        dataIndex: ["name", i18n.language],
                    },
                    {
                        key: "code",
                        title: t("column_function_code"),
                        dataIndex: ["code"],
                    },
                    {
                        key: "organization",
                        title: t("column_organization"),
                        dataIndex: ["organizations"],
                        render: (_, record) => {
                            return (<ul>
                                {
                                    record.organizations.map(o => (<li>{o.name.uz}</li>))
                                }
                            </ul>)
                        },
                    },
                    {
                        key: "group",
                        title: t("column_function_group"),
                        dataIndex: ["functionGroup", "name"],
                    },
                    {
                        key: "link",
                        title: t("column_function_link"),
                        dataIndex: ["link"],
                        render: (_, record) => <div dangerouslySetInnerHTML={{ __html: renderTextWithLink(record.link) }} />
                    },
                    {
                        key: "level",
                        title: t("column_function_level"),
                        dataIndex: ["level"],
                        render: (_, record) => <span>{t(record.level)}</span>
                    },
                ]}
                dataSource={functionNames}
                pagination={false}
                loading={!isFunctionNamesFetched}
            />

            <Spacer size={32} />

            <Pagination
                current={meta.current}
                perPage={meta.perPage}
                total={meta.totalPages}
                currentItems={functionNames.length}
                totalItems={meta.totalItems}
                onChange={(page) => setParams({ page })}
                onPerPageChange={perPage => setParams({ perPage })}
            />

            <Spacer size={140} />
        </Container>
    )
}

export default FunctionNames;